import Icon from '@ant-design/icons'
import React from 'react'

export const MyIcon = ({ component, ...props }) => {
	return <Icon component={component} {...props}  />
}